function OptionCard({ type, label, checked, onChange }) {
  const isRadio = type === "radio";

  return (
    <label className="block cursor-pointer transition-all duration-200 select-none outline-none [-webkit-tap-highlight-color:transparent]">
      <input
        type={type}
        checked={checked}
        onChange={onChange}
        className="hidden"
      />
      <div
        className={`
          flex items-center justify-between
          px-3.5 md:px-5 py-3 md:py-[1.4rem]
          bg-white border rounded-[14px] md:rounded-2xl
          font-medium min-h-[54px] md:min-h-[60px] w-full
          transition-all duration-200
          shadow-[0_1px_4px_rgba(0,0,0,0)]
          hover:text-green hover:scale-[1.01] hover:shadow-[0_10px_14px_rgba(0,0,0,0.01)]
          active:scale-[0.99] active:transition-transform active:duration-300 active:ease-[cubic-bezier(0.34,1.56,0.64,1)]
          ${
            checked
              ? "border-green bg-secondary text-green scale-[0.999]"
              : "border-transparent"
          }
        `}
      >
        <span className="text-[0.95rem] md:text-base flex-grow leading-[1.4]">
          {label}
        </span>

        {isRadio ? (
          // Arrow icon for radio
          <img
            src={`${window.template_root}/src/public/img/next.svg`}
            alt=""
            className={`w-5 h-5 md:w-[22px] md:h-[22px] shrink-0 transition-opacity duration-200 ${
              checked ? "opacity-100" : "opacity-30"
            }`}
          />
        ) : (
          // Checkbox icon
          <div
            className={`
              w-5 h-5 md:w-[22px] md:h-[22px] shrink-0
              border-2 rounded-md
              flex items-center justify-center
              transition-all duration-200
              ${
                checked ? "bg-green border-green" : "bg-white border-light-gray"
              }
            `}
          >
            <img
              src={`${window.template_root}/src/public/img/check.svg`}
              alt=""
              className={`w-4 h-4 transition-opacity duration-200 brightness-0 invert ${
                checked ? "opacity-100" : "opacity-0"
              }`}
            />
          </div>
        )}
      </div>
    </label>
  );
}

export default OptionCard;
